import { promises as fs } from 'node:fs';
import getConfig from 'next/config.js';
import messages from './messages.mjs';

const defaultMessages = Object.fromEntries(
  Object.entries(messages)
    .map(([key, { defaultMessage }]) => [key, defaultMessage]),
);

export const addDefaultMessages = (localeMessages) => Object.fromEntries(
  Object.entries(defaultMessages)
    .map(([key, value]) => [key, localeMessages[key] || value]),
);

const loadMessages = async (locale) => JSON.parse(
  await fs.readFile((`./lang/${locale}.json`)),
);

const { assetPrefix } = {
  ...getConfig(),
  ...typeof process === 'undefined' ? {} : {
    assetPrefix: process.env.ASSET_PREFIX,
  },
  // eslint-disable-next-line no-underscore-dangle
  ...typeof window === 'undefined' ? {} : window.__NEXT_DATA__,
};

const withDefaultLocale = (locale) => locale || 'en-IE';

const getMessagesFileUrl = (locale) => `${
  assetPrefix || ''}/_next/static/lang/${
  withDefaultLocale(locale)}.json`;

const localeMessages = typeof window === 'undefined'
  ? {
    'ar-AE': addDefaultMessages(await loadMessages('ar-AE')),
    'ar-DZ': addDefaultMessages(await loadMessages('ar-DZ')),
    'ar-EG': addDefaultMessages(await loadMessages('ar-EG')),
    'ar-JO': addDefaultMessages(await loadMessages('ar-JO')),
    'ar-LB': addDefaultMessages(await loadMessages('ar-LB')),
    'ar-MA': addDefaultMessages(await loadMessages('ar-MA')),
    'ar-SA': addDefaultMessages(await loadMessages('ar-SA')),
    'ar-TN': addDefaultMessages(await loadMessages('ar-TN')),
    'az-AZ': addDefaultMessages(await loadMessages('az-AZ')),
    'bg-BG': addDefaultMessages(await loadMessages('bg-BG')),
    'bn-BD': addDefaultMessages(await loadMessages('bn-BD')),
    'cs-CZ': addDefaultMessages(await loadMessages('cs-CZ')),
    'da-DK': addDefaultMessages(await loadMessages('da-DK')),
    'de-AT': addDefaultMessages(await loadMessages('de-AT')),
    'de-CH': addDefaultMessages(await loadMessages('de-CH')),
    'de-DE': addDefaultMessages(await loadMessages('de-DE')),
    'el-CY': addDefaultMessages(await loadMessages('el-CY')),
    'el-GR': addDefaultMessages(await loadMessages('el-GR')),
    'en-AU': addDefaultMessages(await loadMessages('en-AU')),
    'en-CA': addDefaultMessages(await loadMessages('en-CA')),
    'en-GB': addDefaultMessages(await loadMessages('en-GB')),
    'en-GH': addDefaultMessages(await loadMessages('en-GH')),
    'en-IE': addDefaultMessages(await loadMessages('en-IE')),
    'en-IN': addDefaultMessages(await loadMessages('en-IN')),
    'en-NG': addDefaultMessages(await loadMessages('en-NG')),
    'en-NZ': addDefaultMessages(await loadMessages('en-NZ')),
    'en-SG': addDefaultMessages(await loadMessages('en-SG')),
    'en-US': addDefaultMessages(await loadMessages('en-US')),
    'en-ZA': addDefaultMessages(await loadMessages('en-ZA')),
    'es-AR': addDefaultMessages(await loadMessages('es-AR')),
    'es-BO': addDefaultMessages(await loadMessages('es-BO')),
    'es-CL': addDefaultMessages(await loadMessages('es-CL')),
    'es-CO': addDefaultMessages(await loadMessages('es-CO')),
    'es-CR': addDefaultMessages(await loadMessages('es-CR')),
    'es-DO': addDefaultMessages(await loadMessages('es-DO')),
    'es-EC': addDefaultMessages(await loadMessages('es-EC')),
    'es-ES': addDefaultMessages(await loadMessages('es-ES')),
    'es-GT': addDefaultMessages(await loadMessages('es-GT')),
    'es-HN': addDefaultMessages(await loadMessages('es-HN')),
    'es-MX': addDefaultMessages(await loadMessages('es-MX')),
    'es-PA': addDefaultMessages(await loadMessages('es-PA')),
    'es-PE': addDefaultMessages(await loadMessages('es-PE')),
    'es-PR': addDefaultMessages(await loadMessages('es-PR')),
    'es-PY': addDefaultMessages(await loadMessages('es-PY')),
    'es-SV': addDefaultMessages(await loadMessages('es-SV')),
    'es-UY': addDefaultMessages(await loadMessages('es-UY')),
    'es-VE': addDefaultMessages(await loadMessages('es-VE')),
    'et-EE': addDefaultMessages(await loadMessages('et-EE')),
    'fi-FI': addDefaultMessages(await loadMessages('fi-FI')),
    'fil-PH': addDefaultMessages(await loadMessages('fil-PH')),
    'fr-BE': addDefaultMessages(await loadMessages('fr-BE')),
    'fr-CA': addDefaultMessages(await loadMessages('fr-CA')),
    'fr-CH': addDefaultMessages(await loadMessages('fr-CH')),
    'fr-CI': addDefaultMessages(await loadMessages('fr-CI')),
    'fr-FR': addDefaultMessages(await loadMessages('fr-FR')),
    'fr-LU': addDefaultMessages(await loadMessages('fr-LU')),
    'fr-SN': addDefaultMessages(await loadMessages('fr-SN')),
    'he-IL': addDefaultMessages(await loadMessages('he-IL')),
    'hr-HR': addDefaultMessages(await loadMessages('hr-HR')),
    'hu-HU': addDefaultMessages(await loadMessages('hu-HU')),
    'id-ID': addDefaultMessages(await loadMessages('id-ID')),
    'it-CH': addDefaultMessages(await loadMessages('it-CH')),
    'it-IT': addDefaultMessages(await loadMessages('it-IT')),
    'ja-JP': addDefaultMessages(await loadMessages('ja-JP')),
    'ka-GE': addDefaultMessages(await loadMessages('ka-GE')),
    'kk-KZ': addDefaultMessages(await loadMessages('kk-KZ')),
    'km-KH': addDefaultMessages(await loadMessages('km-KH')),
    'ko-KR': addDefaultMessages(await loadMessages('ko-KR')),
    'lt-LT': addDefaultMessages(await loadMessages('lt-LT')),
    'lv-LV': addDefaultMessages(await loadMessages('lv-LV')),
    'mg-MG': addDefaultMessages(await loadMessages('mg-MG')),
    'ms-MY': addDefaultMessages(await loadMessages('ms-MY')),
    'mt-MT': addDefaultMessages(await loadMessages('mt-MT')),
    'nb-NO': addDefaultMessages(await loadMessages('nb-NO')),
    'ne-NP': addDefaultMessages(await loadMessages('ne-NP')),
    'nl-BE': addDefaultMessages(await loadMessages('nl-BE')),
    'nl-NL': addDefaultMessages(await loadMessages('nl-NL')),
    'pl-PL': addDefaultMessages(await loadMessages('pl-PL')),
    'pt-BR': addDefaultMessages(await loadMessages('pt-BR')),
    'pt-PT': addDefaultMessages(await loadMessages('pt-PT')),
    'ro-RO': addDefaultMessages(await loadMessages('ro-RO')),
    'ru-RU': addDefaultMessages(await loadMessages('ru-RU')),
    'si-LK': addDefaultMessages(await loadMessages('si-LK')),
    'sk-SK': addDefaultMessages(await loadMessages('sk-SK')),
    'sl-SI': addDefaultMessages(await loadMessages('sl-SI')),
    'sr-RS': addDefaultMessages(await loadMessages('sr-RS')),
    'sv-SE': addDefaultMessages(await loadMessages('sv-SE')),
    'sw-KE': addDefaultMessages(await loadMessages('sw-KE')),
    'th-TH': addDefaultMessages(await loadMessages('th-TH')),
    'tr-TR': addDefaultMessages(await loadMessages('tr-TR')),
    'uk-UA': addDefaultMessages(await loadMessages('uk-UA')),
    'ur-PK': addDefaultMessages(await loadMessages('ur-PK')),
    'uz-UZ': addDefaultMessages(await loadMessages('uz-UZ')),
    'vi-VN': addDefaultMessages(await loadMessages('vi-VN')),
    'zh-CN': addDefaultMessages(await loadMessages('zh-CN')),
    'zh-HK': addDefaultMessages(await loadMessages('zh-HK')),
    'zh-TW': addDefaultMessages(await loadMessages('zh-TW')),
  }
  : {
    // eslint-disable-next-line no-underscore-dangle
    [withDefaultLocale(window.__NEXT_DATA__.props.locale)]: addDefaultMessages(
      await (async () => {
        // eslint-disable-next-line @stylistic/max-len, no-underscore-dangle
        const response = await fetch(getMessagesFileUrl(window.__NEXT_DATA__.props.locale));

        return response.json();
      })(),
    ),
  };

const getMessages = (locale) => localeMessages[withDefaultLocale(locale)];

export {
  getMessages,
  getMessagesFileUrl,
};
